const SALESFORCE = 'Salesforce';
const MODULE_HANDLE_CHAT_CONTACT = 'contact';
const MODULE_HANDLE_CHAT_CONVERSATION = 'conversation';
const MODULE_HANDLE_SALESFORCE_CONTACT = 'Contact';
const MODULE_LABEL_CHAT_CONVERSATION = 'Conversation';
const MODULE_HANDLE_SALESFORCE_LEAD = 'Lead';
const CONNECTION_CATEGORY_PRIMARY = 'primary'

const EXISTING_PRIMARY_ATTRIBUTE_ID = 'existingPrimaryAttributeId';
const USE_EXISTING_PRIMARY_ATTRIBUTE = 'useExistingPrimaryAttribute';
const NEW_PRIMARY_ATTRIBUTE_KEY = 'newPrimaryAttributeKey';
const NEW_PRIMARY_ATTRIBUTE_TYPE = 'newPrimaryAttributeType';
const NEW_PRIMARY_ATTRIBUTE_OPTIONS = 'newPrimaryAttributeOptions';
const NEW_PRIMARY_ATTRIBUTE_OPTIONS_LEGEND = 'newPrimaryAttributeOptionsLegend';
const SECONDARY_ATTRIBUTE_ID = 'secondaryAttributeId';
const SECONDARY_MODULE = 'secondaryModule';

const GECKO_ACADEMY_INTEGRATING_CONTACTS_URL = 'https://academy.geckoengage.com/en/articles/6896421-salesforce#h_2015560bd2'
const GECKO_ACADEMY_INTEGRATING_CONVERSATIONS_URL = 'https://academy.geckoengage.com/en/articles/6896421-salesforce#h_762060855a'

module.exports = {
  SALESFORCE,
  MODULE_HANDLE_CHAT_CONTACT,
  MODULE_HANDLE_CHAT_CONVERSATION,
  MODULE_HANDLE_SALESFORCE_CONTACT,
  MODULE_HANDLE_SALESFORCE_LEAD,
  CONNECTION_CATEGORY_PRIMARY,
  MODULE_LABEL_CHAT_CONVERSATION,
  EXISTING_PRIMARY_ATTRIBUTE_ID,
  USE_EXISTING_PRIMARY_ATTRIBUTE,
  NEW_PRIMARY_ATTRIBUTE_KEY,
  NEW_PRIMARY_ATTRIBUTE_TYPE,
  NEW_PRIMARY_ATTRIBUTE_OPTIONS,
  NEW_PRIMARY_ATTRIBUTE_OPTIONS_LEGEND,
  SECONDARY_ATTRIBUTE_ID,
  SECONDARY_MODULE,
  GECKO_ACADEMY_INTEGRATING_CONTACTS_URL,
  GECKO_ACADEMY_INTEGRATING_CONVERSATIONS_URL
};
